// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"37238d69","886":"57250b5a"}[chunkId] + ".chunk.css";
};